import { Dictionary, keyBy } from 'lodash';
import { useMemo } from 'react';
import { Field } from 'api/tasks';
import { useProjectFieldsQuery } from 'queries';
import { FieldType, filterableFieldType } from '../tasks/fields';

const allowedFieldType = [FieldType.SingleSelect, FieldType.MultiSelect];

interface Result {
  projectFieldsLookupById: Dictionary<Field>;
  isProjectFieldsLoading: boolean;
  projectFields: Field[];
}
export const useProjectFieldsForAIFillConfig = (): Result => {
  const { data: projectFields, isLoading: isProjectFieldsLoading } =
    useProjectFieldsQuery();
  const allowedFields = useMemo(
    () =>
      (projectFields ?? []).filter((field) =>
        allowedFieldType.includes(filterableFieldType(field)),
      ),
    [projectFields],
  );
  const projectFieldsLookup = useMemo(
    () => keyBy(allowedFields, 'fieldId'),
    [allowedFields],
  );

  return {
    projectFieldsLookupById: projectFieldsLookup,
    isProjectFieldsLoading,
    projectFields: allowedFields,
  };
};
